// extracted by mini-css-extract-plugin
module.exports = {"printTypeOptLabel":"PrintTypeOptions_printTypeOptLabel__uPpvh","printTypeOptSelect":"PrintTypeOptions_printTypeOptSelect__1JQAO"};